import type { CSSProperties } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import styles from './FaPortalLinkIcon.module.css';

interface Props {
  link: string;
  bgc: string;
  faIcon: IconDefinition;
}

export function FaPortalLinkIcon({ link, bgc, faIcon }: Props) {
  const cssVars = { '--portal-bgc': bgc } as CSSProperties;

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.iconLink}
      style={cssVars}
    >
      <span className={styles.iconInner} style={cssVars}>
        <FontAwesomeIcon className={styles.faIcon} icon={faIcon} />
      </span>
    </a>
  );
}
